import { Button } from 'ui/Button';
import styles from './OrderDocuments.module.scss';
import { useGetOrderQuery } from 'redux/Api/ordersApi/ordersApi';
import { useParams } from 'react-router-dom';
import { getFormatPhone } from 'utils/getFotmatPhone';
import { ReactComponent as IconDownload } from './img/iconDownload.svg';
import { ReactComponent as IconDownloadGray } from './img/iconDownloadGray.svg';
import { useState } from 'react';
import { downloadFileForOrders } from 'api/getApi';
import { ReactComponent as PdfSvg } from './img/pdf.svg';
import { ReactComponent as IconSBP } from './img/iconSBP.svg';
import { Loader } from '@mantine/core';

interface ElemType {
  created_at?: string;
  number?: string;
  title?: string;
  type?: string;
  is_canceled?: boolean;
}

export const OrderDocuments = () => {
  const role = localStorage.getItem('role');

  const { id } = useParams();
  const { data, isLoading } = useGetOrderQuery({ id });

  const [itemDownload, setItemDownload] = useState<number[]>([]);

  const downloadFile = async (elem: ElemType, index: number) => {
    try {
      const response = await downloadFileForOrders(role === 'worksupport' && role, id, {
        type: elem.type,
      });

      if (!response.data) {
        throw new Error('Ошибка при загрузке файла');
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = elem.number || '';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();

      window.open(url, '_blank');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setItemDownload((prev) => prev.filter((item) => item !== index));
    }
  };

  if (isLoading) return null;

  return data?.docs?.length ? (
    <div className={styles.documents}>
      <div className={styles.documents_title}>
        <p>Документы</p>
      </div>
      <div className={styles.documents_item}>
        {data?.docs?.map((elem, i) => (
          <div key={i} className={styles.documents_item__doc}>
            <div className={styles.doc}>
              <PdfSvg />
              <p>
                {elem?.number} {elem?.created_at ? ` от ${elem?.created_at}` : ''}
              </p>
            </div>
            <div className={styles.actions}>
              <Button
                theme='outline'
                className={styles.actions_btn}
                onClick={() => {
                  downloadFile(elem, i);
                  setItemDownload((prev) => [...prev, i]);
                }}>
                <div className={styles.btntext}>
                  {'Скачать'}
                  <div style={{ width: '16px', height: '16px' }}>
                    {itemDownload.includes(i) ? (
                      <Loader size='xs' color='#002CFB' />
                    ) : (
                      <IconDownload style={{ width: '16px', height: '16px' }} />
                    )}
                  </div>
                </div>
              </Button>
            </div>
            <div
              className={styles.actions_mobile}
              onClick={() => {
                downloadFile(elem, i);
                setItemDownload((prev) => [...prev, i]);
              }}>
              <IconDownloadGray style={{ width: '20px', height: '20px' }} />
            </div>
          </div>
        ))}
        {data?.payment?.type === 'to_sbp' && (
          <div className={styles.documents_item__doc}>
            <div className={styles.doc}>
              <IconSBP />
              <div className={styles.requisites}>
                <span className={styles.phone}>
                  {getFormatPhone(data?.payment?.requisites?.phone)}
                </span>
                <span className={styles.bank}>{data?.payment?.requisites?.bank}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : null;
};
